import { Box } from '@src/common/components/Box';
import { Divider } from '@src/common/components/Divider';
import { Stack } from '@src/common/components/Stack';
import { Typography } from '@src/common/components/Typography';
import { css } from '@src/common/styles/Styles';
import { theme } from '@src/common/styles/Theme';
import { colors } from '@src/common/styles/valueTokens';
import type { ReactNode } from 'react';

interface PanelSections {
  sections: Array<{
    title: string;
    subtitle?: string;
    content: ReactNode;
  }>;
}

interface Props {
  panels: Array<PanelSections>;
}
export const MultiPanelContainer = ({ panels }: Props) => {
  return (
    <Stack className={multiPanelsContainer}>
      {panels.map((panel, index) => (
        <MultiPanelContainerSection key={index} sections={panel.sections} />
      ))}
    </Stack>
  );
};

const MultiPanelContainerSection = (panel: PanelSections) => {
  return (
    <Stack
      className={multiPanelsContainerSection}
      aria-label="Panel"
      direction="column"
    >
      {panel.sections.map((section, index) => (
        <Box
          key={index}
          aria-label={section.title}
          display="flex"
          flexWrap="wrap"
          flexDirection="column"
          flex="auto"
          gap={theme.spacing['3']}
        >
          <Typography variant="subtitle1">
            {section.title}
            <Divider />
          </Typography>
          {section.subtitle && (
            <Typography style={{ color: colors.text.secondary }}>
              {section.subtitle}
            </Typography>
          )}
          {section.content}
        </Box>
      ))}
    </Stack>
  );
};

const multiPanelsContainer = css({
  backgroundColor: theme.palette.surface.surfaceContainerLowest,
  flexDirection: 'row',
  gap: theme.spacing['3'],
  height: 'fit-content',
});

const multiPanelsContainerSection = css({
  backgroundColor: theme.palette.surface.surfaceContainerLowest,
  padding: theme.spacing['5'],
  flexDirection: 'column',
  gap: theme.spacing['3'],
  height: 'fit-content',
  flex: 1,
});
